import { QuotationCoverageInsuredDO, QuotationCoverageScheduleDO, QuotationCoverageAdditionalFieldDO } from './';


import { BaseDO } from './base.model';
 
export class QuotationCoverageDO extends BaseDO {

	public id: Number = null;

	public planTypeCd: String = null;

	public productCd: String = null;

	public productVersion: Number = null;

	public associationType: String = null;

	public planOptionCd: String = null;

	public sumInsured: any = null;

	public primaryInsuredValue: any = null;

	public totOtherInsurableValue: any = null;

	public estimatedSumInsured: any = null;

	public totalPremium: any = null;

	public totalExtraPremium: any = null;

	public baseAnnualPremium: any = null;

	public baseModalPremium: any = null;

	public premiumRate: Number = null;

	public term: Number = null;

	public commencementDt: Date = null;

	public expiryDt: Date = null;

	public uwDecisionCd: String = null;

	public uwDecisionValue: String = null;

	public coverageUIProperty: String = null;

	public coverageUIPropertyValue: String = null;

	public productTypeCd: String = null;

	public ratingTypeCd: String = null;

	public sortOrder: Number =null;

	public quotationCoverageAdditionalFieldList: QuotationCoverageAdditionalFieldDO[] = [];

	public quotationCoverageInsuredList: QuotationCoverageInsuredDO[] = [];

	public quotationCoverageScheduleList: QuotationCoverageScheduleDO[] = [];


	public setId(id) {
		this.id = id;
	}
	public getCoverageUIProperty() {
		return this.coverageUIProperty;
	}

	public setCoverageUIProperty(coverageUIProperty) {
		this.coverageUIProperty = coverageUIProperty;
	}
	public getCoverageUIPropertyValue() {
		return this.coverageUIPropertyValue;
	}
	public setCoverageUIPropertyValue(coverageUIPropertyValue) {
		this.coverageUIPropertyValue = coverageUIPropertyValue;
	}


	public getProductCd() {
		return this.productCd;
	}

	public setProductCd(productCd) {
		this.productCd = productCd;
	}

	public getProductVersion() {
		return this.productVersion;
	}

	public setProductVersion(productVersion) {
		this.productVersion = productVersion;
	}

	public getPlanOptionCd() {
		return this.planOptionCd;
	}

	public setPlanOptionCd(planOptionCd) {
		this.planOptionCd = planOptionCd;
	}

	public getBaseAnnualPremium() {
		return this.baseAnnualPremium;
	}

	public setBaseAnnualPremium(baseAnnualPremium) {
		this.baseAnnualPremium = baseAnnualPremium;
	}

	public getBaseModalPremium() {
		return this.baseModalPremium;
	}

	public setBaseModalPremium(baseModalPremium) {
		this.baseModalPremium = baseModalPremium;
	}

	public getTotalExtraPremium() {
		return this.totalExtraPremium;
	}

	public setTotalExtraPremium(totalExtraPremium) {
		this.totalExtraPremium = totalExtraPremium;
	}

	public getTotalPremium() {
		return this.totalPremium;
	}

	public setTotalPremium(totalPremium) {
		this.totalPremium = totalPremium;
	}

	public getSumInsured() {
		return this.sumInsured;
	}

	public setSumInsured(sumInsured) {
		this.sumInsured = sumInsured;
	}

	public getId() {
		return this.id;
	}

	public getUwDecisionCd() {
		return this.uwDecisionCd;
	}

	public setUwDecisionCd(uwDecisionCd) {
		this.uwDecisionCd = uwDecisionCd;
	}

	public getUwDecisionValue() {
		return this.uwDecisionValue;
	}

	public setUwDecisionValue(uwDecisionValue) {
		this.uwDecisionValue = uwDecisionValue;
	}

	public getPlanTypeCd() {
		return this.planTypeCd;
	}

	public setPlanTypeCd(planTypeCd) {
		this.planTypeCd = planTypeCd;
	}

	public getAssociationType() {
		return this.associationType;
	}
	public setAssociationType(associationType) {
		this.associationType = associationType;
	}
	public getPremiumRate() {
		return this.premiumRate;
	}
	public setPremiumRate(premiumRate) {
		this.premiumRate = premiumRate;
	}
	public getEstimatedSumInsured() {
		return this.estimatedSumInsured;
	}
	public setEstimatedSumInsured(estimatedSumInsured) {
		this.estimatedSumInsured = estimatedSumInsured;
	}

	// public  getObjectName() {
	// 	if(planTypeCd.equals("BASEPLAN")){
	// 		return this.planTypeCd;
	// 	}else{
	// 		return this.PolicyCoverageDO.class.getSimpleName();
	// 	}
	// }

	// public  FormattedSumInsured(){
	// 	return this.sumInsured.to();
	// }
	public getTerm() {
		return this.term;
	}
	public setTerm(term) {
		this.term = term;
	}
	public getCommencementDt() {
		return this.commencementDt;
	}
	public setCommencementDt(commencementDt) {
		this.commencementDt = commencementDt;
	}
	public getExpiryDt() {
		return this.expiryDt;
	}
	public setExpiryDt(expiryDt) {
		this.expiryDt = expiryDt;
	}

	public getQuotationCoverageAdditionalFieldList() {
		return this.quotationCoverageAdditionalFieldList;
	}
	public setQuotationCoverageAdditionalFieldList(quotationCoverageAdditionalFieldList: QuotationCoverageAdditionalFieldDO[]) {
		this.quotationCoverageAdditionalFieldList = quotationCoverageAdditionalFieldList;
	}

	public getQuotationCoverageInsuredList() {
		return this.quotationCoverageInsuredList;
	}
	public setQuotationCoverageInsuredList(quotationCoverageInsuredList: QuotationCoverageInsuredDO[]) {
		this.quotationCoverageInsuredList = quotationCoverageInsuredList;
	}

	public getQuotationCoverageScheduleList() {
		return this.quotationCoverageScheduleList;
	}
	public setQuotationCoverageScheduleList(quotationCoverageScheduleList: QuotationCoverageScheduleDO[]) {
		this.quotationCoverageScheduleList = quotationCoverageScheduleList;
	}

}
